import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {BehaviorSubject, catchError, finalize, forkJoin, Observable, of, switchMap} from "rxjs";
import {environment} from "../../environments/environment";
import {CountryService} from "./country.service";
import {NotificationService} from "./notification.service";
import {EnergySource} from "../model/energy-source"; // Pfad anpassen falls nötig

@Injectable({
  providedIn: 'root'
})
export class EnergySourcesService {
  private readonly energySourcesUrl = `${environment.backend.baseUrl}/energy-sources`

  data$: Observable<EnergySource[] | null>

  private loadingSubject = new BehaviorSubject<boolean>(false)
  loading$ = this.loadingSubject.asObservable()

  constructor(
    private country: CountryService,
    private http: HttpClient,
    private notification: NotificationService
  ) {
    this.data$ = this.country.selected$.pipe(
      switchMap((countryCode) => {
        if (!countryCode) {
          return of(null)
        }

        const params = new HttpParams()
          .set('countryCode', countryCode)

        this.loadingSubject.next(true)

        return this.http.get<EnergySource[]>(this.energySourcesUrl, {params: params}).pipe(
          catchError((err: HttpErrorResponse) => {
            switch (err.status) {
              case 0: {
                this.notification.error('Could not reach backend to fetch energy sources')
                break;
              }
              case 403: {
                this.notification.error(`You are not authorized to query energy sources for '${countryCode}'`)
                break;
              }
              default: {
                this.notification.error('Error while fetching energy sources')
                break;
              }
            }
            return of(null)
          }),
          finalize(() => this.loadingSubject.next(false))
        )
      })
    )
  }

  putEnergySources(energySources: EnergySource[]) {
    let updateObservables: Observable<EnergySource>[] = []
    energySources.forEach(source => {
      updateObservables.push(this.http.put<EnergySource>(this.energySourcesUrl, source))
    })
    return forkJoin<EnergySource[]>(updateObservables)
  }
}
